import users from './data/users.json'

export function configureBackend() {
    
    let realFetch = window.fetch;
    window.fetch = function (url, opts) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (url.endsWith('/users/authenticate') && opts.method === 'POST') {
                    let params = JSON.parse(opts.body);
        
                    let filteredUsers = Object.values(users).filter(user => {
                        
                        return user.username === params.username && user.password === params.password;
                    });

                    if (filteredUsers.length) {
                        let user = filteredUsers[0];
                        let responseJson = {
                            id_user: user.id_user,
                            username: user.username,
                            id_shop: user.id_shop,
                            source: user.source,
                        };
                        sessionStorage.setItem('user', responseJson)
                        resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(responseJson)) });
                    } else {
                        reject('Usuario o contraseña incorrectos');
                    }
                    return;
                }

                if (url.endsWith('/users') && opts.method === 'GET') {
                    if (opts.headers && opts.headers.Authorization === `Basic ${window.btoa('test:test')}`) {
                        console.log(1);
                        resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(users)) });
                    } else {
                        reject('Unauthorised');
                    }
                    return;
                }
                realFetch(url, opts).then(response => resolve(response));
            }, 500);
        });
    }
}